module.exports = __webpack_public_path__ + "img/bg_header_2x.48a6766e.png";